import { useContext } from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';

import { AppContext } from '../contexts/app.context';
import utils from '../utilFn';

import SkillGauge from './SkillGauge';
import styles from './TagCloud.module.scss';

interface Tag {
  value: string;
  score: number;
}

interface TagCloudProps {
  minSize?: number;
  maxSize?: number;
  baseColor?: string;
  tags: Tag[];
  order?: 'random' | 'score' | 'value';
  scoreBase?: number;
  placement?: 'top' | 'bottom' | 'left' | 'right';
}

const TagCloud = ({
  minSize = 1,
  maxSize = 5,
  baseColor = '#0572ce',
  tags = [],
  order = 'random',
  scoreBase = 100,
  placement = 'bottom',
}: TagCloudProps) => {
  const { season } = useContext(AppContext);
  const tagData = tags.sort((a: Tag, b: Tag) => {
    if (order === 'random') return utils.randomSort();
    if (order === 'score') return a.score - b.score;
    if (order === 'value') {
      if (a.value > b.value) return 1;
      else if (a.value < b.value) return -1;
    }
    return 0;
  });

  const popover = (tag: Tag) => (
    <Popover bsPrefix={season}>
      <Popover.Body>
        <SkillGauge level={(tag.score / scoreBase) * 5} color={baseColor} />
      </Popover.Body>
    </Popover>
  );

  return (
    <div className={styles['tagcloud-wrapper']} style={{ color: baseColor }}>
      {tagData.map((tag) => {
        const fontSize =
          minSize + (maxSize - minSize) * (tag.score / scoreBase);
        return (
          <OverlayTrigger
            key={tag.value}
            trigger={['hover', 'focus']}
            placement={placement}
            overlay={popover(tag)}
          >
            <a
              style={{ fontSize: `${fontSize}rem` }}
              role="button"
              href="#"
              className={styles['tagcloud-popover-trigger']}
              onClick={(e: React.MouseEvent) => e.preventDefault()}
            >
              {tag.value}
            </a>
          </OverlayTrigger>
        );
      })}
    </div>
  );
};

export default TagCloud;
